/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Switch_To_Annual_ButtonInputs */

const en_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to annual`)
};

const id_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganti ke tahunan`)
};

const ms_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukar kepada tahunan`)
};

const ca_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canviar a anual`)
};

const cs_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přejít na roční`)
};

const da_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skift til årligt`)
};

const de_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Jahresabo wechseln`)
};

const et_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vali aastatellimus`)
};

const es_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar al plan anual`)
};

const fr_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer à l’abonnement annuel`)
};

const hr_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prebacite se na godišnju pretplatu`)
};

const it_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa ad annuale`)
};

const lv_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pāriet uz gada plānu`)
};

const lt_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keisti į metinį planą`)
};

const hu_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Váltson éves előfizetésre`)
};

const nl_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overstappen naar jaarabonnement`)
};

const nb_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bytt til årsabonnement`)
};

const pl_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź na płatność roczną`)
};

const pt_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterar para anual`)
};

const ro_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treci la anual`)
};

const sk_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepnúť na ročné`)
};

const sl_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prehod na letno`)
};

const fi_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaihda vuosittaiseen`)
};

const sv_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Växla till årlig`)
};

const vi_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyển sang hằng năm`)
};

const tr_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yıllık plana geçin`)
};

const el_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αλλαγή σε ετήσια`)
};

const bg_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преминаване към годишен`)
};

const ru_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти на годовую`)
};

const sr_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пређите на годишњу`)
};

const uk_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти на річну підписку`)
};

const ka_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`წლიურზე გადართვა`)
};

const hi_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एनुअल में स्विच करें`)
};

const th_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปลี่ยนเป็นรายปี`)
};

const ko_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연간 구독으로 전환`)
};

const zh_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换到年度订阅`)
};

const zh_tw_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轉換為年費方案`)
};

const ja_switch_to_annual_button = /** @type {(inputs: Switch_To_Annual_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年間プランに変更`)
};

/**
* | output |
* | --- |
* | "Switch to annual" |
*
* @param {Switch_To_Annual_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const switch_to_annual_button = /** @type {((inputs?: Switch_To_Annual_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Switch_To_Annual_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_switch_to_annual_button(inputs)
	if (locale === "ms") return ms_switch_to_annual_button(inputs)
	if (locale === "ca") return ca_switch_to_annual_button(inputs)
	if (locale === "cs") return cs_switch_to_annual_button(inputs)
	if (locale === "da") return da_switch_to_annual_button(inputs)
	if (locale === "de") return de_switch_to_annual_button(inputs)
	if (locale === "et") return et_switch_to_annual_button(inputs)
	if (locale === "es") return es_switch_to_annual_button(inputs)
	if (locale === "fr") return fr_switch_to_annual_button(inputs)
	if (locale === "hr") return hr_switch_to_annual_button(inputs)
	if (locale === "it") return it_switch_to_annual_button(inputs)
	if (locale === "lv") return lv_switch_to_annual_button(inputs)
	if (locale === "lt") return lt_switch_to_annual_button(inputs)
	if (locale === "hu") return hu_switch_to_annual_button(inputs)
	if (locale === "nl") return nl_switch_to_annual_button(inputs)
	if (locale === "nb") return nb_switch_to_annual_button(inputs)
	if (locale === "pl") return pl_switch_to_annual_button(inputs)
	if (locale === "pt") return pt_switch_to_annual_button(inputs)
	if (locale === "ro") return ro_switch_to_annual_button(inputs)
	if (locale === "sk") return sk_switch_to_annual_button(inputs)
	if (locale === "sl") return sl_switch_to_annual_button(inputs)
	if (locale === "fi") return fi_switch_to_annual_button(inputs)
	if (locale === "sv") return sv_switch_to_annual_button(inputs)
	if (locale === "vi") return vi_switch_to_annual_button(inputs)
	if (locale === "tr") return tr_switch_to_annual_button(inputs)
	if (locale === "el") return el_switch_to_annual_button(inputs)
	if (locale === "bg") return bg_switch_to_annual_button(inputs)
	if (locale === "ru") return ru_switch_to_annual_button(inputs)
	if (locale === "sr") return sr_switch_to_annual_button(inputs)
	if (locale === "uk") return uk_switch_to_annual_button(inputs)
	if (locale === "ka") return ka_switch_to_annual_button(inputs)
	if (locale === "hi") return hi_switch_to_annual_button(inputs)
	if (locale === "th") return th_switch_to_annual_button(inputs)
	if (locale === "ko") return ko_switch_to_annual_button(inputs)
	if (locale === "zh") return zh_switch_to_annual_button(inputs)
	if (locale === "zh-tw") return zh_tw_switch_to_annual_button(inputs)
	if (locale === "ja") return ja_switch_to_annual_button(inputs)
	return en_switch_to_annual_button(inputs)
});